export default "__VITE_ASSET__260561db__"